import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { Watch } from "react-loader-spinner";
import Swal from "sweetalert2";
import { startDownloadTechnologyData, startDownloadTechnologyDataExample, startImportDataTechnologyClean, startUploadingTechnologyDataLocalPaginated } from "../../app/actions/importDataTechnologyActions";
import ReactPaginateComponent from "../generic-ui/ReactPaginateComponent";
import Select from "../generic-ui/Select";
import TableDataBootstrap from "./TableDataBootstrap";
import BulkUploadGate from "../specialist-flow-engine/BulkUploadGate";
import ImportDataSheetNote from "../specialist-flow-engine/ImportDataSheetNote";
import useImportResultLabels from "../../app/hooks/useImportResultLabels";

const UploadTechnologyData = () => {

  const listOptions = [2, 3, 4, 5, 10, 15, 20, 25, 50, 100];

  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { savedColumnLabel, savedSummaryLabel } = useImportResultLabels();

  const [selectedFileState, setselectedFileState] = useState(null);
  const [isEnableToSave, setIsEnableToSave] = useState("false");
  const inputRef = useRef(null);
  const [isSelectedFileSelected, setIsSelectedFileSelected] = useState(false);
  const [typeFileError, setTypeFileError] = useState("");
  const [importFileEnabled, setImportFileEnabled] = useState(false);
  const [downloadFileEnabled, setDownloadFileEnabled] = useState(false);

  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [, setCurrentPageClick] = useState(0);

  const {
    bagRowProcess,
    totalRows,
    numberOfRowsValid,
    numberOfRowsSaved,
    numberOfRowsInvalid,
    isFetching,
    totalItems,
    totalPages,
    currentPage,
    technologiesBulkListP
  } =
    useSelector((state) => state.importDataTechnology);

  useEffect(() => {
    resetForm();
  }, []);

  useEffect(() => {
    if (totalItems && totalItems > 0) {
      setDownloadFileEnabled(true);
    }

  }, [totalItems])

  const handleChangeIsEnableToSaveFile = (e) => {
    
    setIsEnableToSave(e.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (selectedFileState) {
      
      dispatch(startImportDataTechnologyClean());

      dispatch(startUploadingTechnologyDataLocalPaginated(selectedFileState, isEnableToSave, 0, itemsPerPage));
    } else {
      Swal.fire(t("titles.error"), t("record.condition_file_import"), "error");
    }
  };

  const handleChangeFile = (event) => {
    
    setTypeFileError("");

    if (
      event.target.files[0].type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      
    ) {
      setselectedFileState(event.target.files[0]);
      setIsSelectedFileSelected(true);
      setImportFileEnabled(true);
    } else {
      setTypeFileError("Error formato de archivo invalido");
    }
  };

  const resetFileInput = (e) => {
    e.preventDefault();
    resetForm();
  };

  const resetForm = () => {
    if (inputRef.current) {
      inputRef.current.value = null;
    }
    setIsEnableToSave("false")
    setIsSelectedFileSelected(false);
    setTypeFileError("");
    setImportFileEnabled(false);
    setDownloadFileEnabled(false);

    dispatch(startImportDataTechnologyClean());
  };

  const handleDownload = (e) => {
    e.preventDefault();
    
    dispatch(startDownloadTechnologyData(bagRowProcess));

  }

  const handleDownloadExample = (e) => {
    e.preventDefault();
    dispatch(startDownloadTechnologyDataExample());
  }

  const onPageChangeReactPaginate = (pageClick) => {
    const pageClickRP = pageClick && pageClick.selected + 1

    if (technologiesBulkListP && technologiesBulkListP.length > 0) {
      dispatch(startUploadingTechnologyDataLocalPaginated(selectedFileState, isEnableToSave, pageClickRP - 1, itemsPerPage));
    } else {
      
    }
    setCurrentPageClick(pageClick);
  };

  const onChangeSelect = (event) => {

    if (technologiesBulkListP && technologiesBulkListP.length > 0) {
      dispatch(startUploadingTechnologyDataLocalPaginated(selectedFileState, isEnableToSave, 0, event.target.value));
    } else {

    }
    setCurrentPageClick(0);
    setItemsPerPage(event.target.value);
  };

  const tab = "\u00A0";

  return (
    <BulkUploadGate moduleProcess="technology">
    <div>
      <div className="section is-fullheight">
        <div className="container">
          <form onSubmit={handleSubmit} noValidate>
            <div className="row">
              <div className="col-md-8 text-start">
                <p>
                  <ImportDataSheetNote />
                </p>
              </div>
              <div className="col-md-4">
                <button onClick={handleDownloadExample}>{t("admin.importdata.download")}</button>
              </div>

            </div>
            <hr />
            <div className="row">

              <div className="col-md-3">
                <label className="form-label">{t("admin.importdata.radio.saveCorrect")}</label>
                <div className="control">
                  <label>
                    <input id="radio_yes" type="radio" value="true" checked={isEnableToSave === 'true'} onChange={handleChangeIsEnableToSaveFile} />
                    <span style={{ paddingLeft: "10px" }}>{t("admin.importdata.radio.yes")}</span>
                    <span>
                      {tab}|{tab}
                    </span>
                  </label>
                  <label>
                    <input id="radio_no" type="radio" value="false" checked={isEnableToSave === 'false'} onChange={handleChangeIsEnableToSaveFile} />
                    <span style={{ paddingLeft: "10px" }}>{t("admin.importdata.radio.no")}</span>
                  </label>
                </div>
              </div>

              <div className="col-md-8">
                <div>
                  <label htmlFor="group-file" className="form-label">
                    {t("admin.importdata.text.file")}
                  </label>
                  <div id="group-file" className="input-group custom-file-button">

                    <input
                      style={{ paddingRight: "0px" }}
                      ref={inputRef}
                      type="file"
                      className="form-control"
                      id="inputGroupFile"
                      onChange={handleChangeFile}
                    />
                  </div>
                  <span className="note">
                    {t("admin.importdata.text.extensions")}
                    <span>.xlsx</span>
                  </span>
                  <span>{typeFileError}</span>
                </div>

              </div>

              {isSelectedFileSelected && (
                <div className="col-md-1">
                  <button
                    style={{
                      marginTop: "15px",
                      border: "none",
                      paddingTop: "20px",
                      background: "none",
                      paddingLeft: "0px"
                    }}
                    onClick={resetFileInput}
                  >
                    <i className="fa fa-window-close fa-2x"></i>
                  </button>
                </div>
              )}

              <div className="col-md-3">
                <br />
                {importFileEnabled &&
                  (
                    <input type="submit" value={t("buttons.import")} className="btn btn-primary form-control" />
                  )
                }

              </div>
            </div>
            <hr />
            {downloadFileEnabled && totalItems && totalItems > 0 ? (
              <div>
                <div className="row">
                  <h3>{t("admin.importdata.text.summary")}</h3>
                  <div className="col-md-3">
                    <span>{t("admin.importdata.summary.total")}</span><strong>{totalRows}</strong>
                  </div>
                  <div className="col-md-3">
                    <span>{savedSummaryLabel}</span><strong>{numberOfRowsSaved}</strong>
                  </div>
                  <div className="col-md-3">
                    <span>{t("admin.importdata.summary.valid")}</span><strong>{numberOfRowsValid}</strong>
                  </div>
                  <div className="col-md-3">
                    <span>{t("admin.importdata.summary.invalid")}</span><strong>{numberOfRowsInvalid}</strong>
                  </div>
                </div>
                <hr />

                <div className="row">
                  <TableDataBootstrap
                    data={technologiesBulkListP}
                    savedColumnLabel={savedColumnLabel} />
                </div>

                <div>
                  <Select
                    listOptions={listOptions}
                    onChangeSelect={onChangeSelect}
                    
                    pageSize={itemsPerPage}
                  />
                </div>

                {totalItems && totalItems > 0 && (
                  <ReactPaginateComponent
                    totalPages={totalPages}
                    itemsPerPage={itemsPerPage}
                    onPageChange={onPageChangeReactPaginate}
                    currentPage={currentPage}
                    marginPagesDisplayed={5}
                  />
                )}
                <button onClick={handleDownload}>{t("admin.importdata.button.download")}</button>

              </div>
            ) : (
              isFetching &&
              (<div>
                <Watch
                  visible={true}
                  height="80"
                  width="80"
                  radius="48"
                  color="#4fa94d"
                  ariaLabel="watch-loading"
                  wrapperStyle={{}}
                  wrapperClass=""
                />
              </div>)
            )

            }

          </form>
        </div >
      </div >
    </div >
    </BulkUploadGate>
  );
};

export default UploadTechnologyData;

